import { useEffect, useState, useRef } from "react";
import { Row, Form, Col, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  InputControl,
  InputValidationConstants,
  SubmitButtonContent,
  TextAreaControl,
  SelectControl,
  TinymceControl,
  createOptionsFromEnum,
  Modal,
  Loading,
  NumberControl,
  CheckboxControl,
  DateTimeControl,
  PageHeader,
  OutputControl,
  createOption,
} from "wup-module1-base";
import {
  RoutePathConstants,
  QuestionTypeEnum,
  DisplayTypeEnum,
} from "../../../Constants";
import { v4 as uuidv4 } from "uuid";
import AnswerModal from "./AnswerModal";
import { getEnumDescriptionByValue } from "wup-module1-base";
import {
  faTrashCan,
  faEdit,
  faArrowUp,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { set } from "date-fns";

/**
 * Modal dodawania pytania
 */
function QuestionModal({
  isEdit = null,
  question = null,
  setQuestion,
  appendQuestion,
  updateQuestion,
  removeQuestion,
  questionFields,
  pageFields,
  replaceQuestions,
}) {
  const {
    register,
    getValues,
    setValue,
    reset,
    trigger,
    watch,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [content, setContent] = useState(question?.content ?? "");
  const [correlatedOptions, setCorrelatedOptions] = useState([]);
  const [correlationAnswers, setCorrelationAnswers] = useState([]);
  const [isAnswerEdit, setIsAnswerEdit] = useState(null);
  const [answerModel, setAnswerModel] = useState(null);
  const [answers, setAnswers] = useState([]);
  const questionType = watch("type");
  const displayType = watch("displayType");
  const answerMin = watch("minValue");
  const answerMax = watch("maxValue");
  const rowNr = watch("rowNr");
  const correlation = watch("relatedQuestionId");
  const typeRegister = register("type", {
    required: InputValidationConstants.required,
  });
  // const displayTypeRegister = register("displayType", {
  //   required: InputValidationConstants.required,
  // });
  const tinymceRef = useRef();

  useEffect(() => {
    handleContentChange(question?.content ?? "");
    if (!!question) {
      setAnswers(question.answers);
      reset(question);
      setTimeout(trigger, 0);
      const currPageIdx = pageFields.indexOf(
        pageFields.find((p) => p.id === question.pageId)
      );
      const currAndAbovePageIds = pageFields
        .filter((p, idx) => idx <= currPageIdx)
        .map((p) => p.id);
      setCorrelatedOptions([
        createOption("(brak)", null),
        ...questionFields
          .filter(
            (i) =>
              i.id !== question.id &&
              // currAndAbovePageIds.includes(i.pageId) &&
              i.pageId === pageFields[currPageIdx].id &&
              // parseInt(i.type) !== QuestionTypeEnum.Content.value &&
              !question.relatedQuestions.map((r) => r.id).includes(i.id)
          )
          .map((i, idx) =>
            createOption(
              i.name ??
                `Pytanie ${
                  questionFields.indexOf(
                    questionFields.find((q) => q.id === i.id)
                  ) + 1
                }`,
              i.id
            )
          ),
      ]);
    }
  }, [question, reset]);

  useEffect(() => {
    if (!!correlation) {
      const questionAnswers = questionFields.find(
        (i) => i.id === correlation
      ).answers;
      setCorrelationAnswers([
        createOption("(wybierz)", null),
        ...questionAnswers.map((ans, idx) =>
          createOption(
            ans.value?.length > 100
              ? ans.value?.substring(0, 100) + "..."
              : ans.value,
            ans.id
          )
        ),
      ]);
    }
  }, [correlation]);

  // useEffect(() => {
  //   setAnswers([]);
  // }, [displayType]);

  useEffect(() => {
    setTimeout(trigger, 10);
  }, [questionType, displayType, answerMin, answerMax, rowNr]);

  function getPredefinedAnswersByType(questionType) {
    switch (questionType) {
      case QuestionTypeEnum.YesNoSelect.value: {
        const yes = {
          id: uuidv4(),
          questionId: question?.id,
          type: questionType,
          isPredefined: true,
          value: "Tak",
        };
        const no = {
          id: uuidv4(),
          questionId: question?.id,
          type: questionType,
          isPredefined: true,
          value: "Nie",
        };
        return [yes, no];
      }
      default:
        return [];
    }
  }

  const handleTypeChange = (type) => {
    //setValue("type", type);
    setValue("minValue", "");
    setValue("maxValue", "");
    setValue("rowNr", "");
    setValue("displayType", "");
    const predefinedAnswers = getPredefinedAnswersByType(parseInt(type));
    setAnswers(predefinedAnswers);
  };

  const handleContentChange = (html) => {
    setContent(html);
    setValue("content", html);
  };

  const addAnswer = () => {
    if (
      parseInt(questionType) === QuestionTypeEnum.YesNoSelect.value &&
      answers.length === 3
    ) {
      toast.info(
        "Dla pytań typu Tak/Nie nie może być więcej niż 3 odpowiedzi! (2 predefiniowane + 1 obligatoryjna)"
      );
      return;
    }
    // if (
    //   parseInt(questionType) === QuestionTypeEnum.OptionList.value &&
    //   answers.length === 1
    // ) {
    //   toast.info("Nie można stworzyć więcej niż jednej listy odpowiedzi");
    //   return;
    // }

    setIsAnswerEdit(false);
    const answer = {
      id: uuidv4(),
      questionId: question.id,
      type: getValues("type"),
      isPredefined: false,
      value: null,
    };
    setAnswerModel(answer);
  };

  const editAnswer = (answer) => {
    setIsAnswerEdit(true);
    setAnswerModel(answer);
  };

  const removeAnswer = (idx) => {
    const copyOfAnswers = [...answers];
    copyOfAnswers.splice(idx, 1);
    setAnswers(copyOfAnswers);
  };

  const answerUp = (idx) => {
    const copyOfAnswers = [...answers];
    [copyOfAnswers[idx], copyOfAnswers[idx - 1]] = [
      copyOfAnswers[idx - 1],
      copyOfAnswers[idx],
    ];
    setAnswers(copyOfAnswers);
  };

  const answerDown = (idx) => {
    const copyOfAnswers = [...answers];
    [copyOfAnswers[idx], copyOfAnswers[idx + 1]] = [
      copyOfAnswers[idx + 1],
      copyOfAnswers[idx],
    ];
    setAnswers(copyOfAnswers);
  };

  const onSubmit = () => {
    const data = getValues();
    const toSubmit = {
      ...data,
      order: question.order,
      id: question.id,
      answers: answers,
      relatedQuestions: question.relatedQuestions,
      pageId: question.pageId,
    };
    setIsSubmitting(true);
    if (!isEdit) {
      const currentPageQuestions = questionFields.filter(
        (i) => i.pageId === question.pageId
      );
      if (currentPageQuestions.length === 0) appendQuestion(toSubmit);
      else {
        const lastPageIdx = questionFields.indexOf(
          currentPageQuestions[currentPageQuestions.length - 1]
        );
        const questionsBefore = questionFields.filter(
          (i, idx) => idx <= lastPageIdx
        );
        const questionsAfter = questionFields.filter(
          (i, idx) => idx > lastPageIdx
        );
        const merged = [...questionsBefore, toSubmit, ...questionsAfter];
        replaceQuestions(merged);
      }
    } else {
      const foundQuestion = questionFields.find((i) => i.id === question.id);
      const questionIdx = questionFields.indexOf(foundQuestion);
      updateQuestion(questionIdx, toSubmit);
    }

    if (!!data.relatedQuestionId) {
      const relatedQuestion = questionFields.find(
        (i) => i.id === data.relatedQuestionId
      );
      const questionIdx = questionFields.indexOf(relatedQuestion);
      const toUpdate = {
        ...relatedQuestion,
        relatedQuestions: [...relatedQuestion.relatedQuestions, toSubmit],
      };
      if (isEdit) {
        const copy = [...relatedQuestion.relatedQuestions];
        const relatedOfCopy = copy.find((i) => i.id === toSubmit.id);
        if (relatedOfCopy) {
          const copyIdx = copy.indexOf(relatedOfCopy);
          copy[copyIdx] = toSubmit;
          toUpdate.relatedQuestions = copy;
        }
      }
      updateQuestion(questionIdx, toUpdate);
    }

    handleContentChange("");
    // tinymceRef.current.handleContentChange("");
    setIsSubmitting(false);
    setCorrelatedOptions([]);
    setAnswers([]);
    setQuestion(null);
  };

  return (
    <>
      <Modal
        show={!!question}
        size={"xl"}
        title={`${isEdit ? "Edycja" : "Dodawanie"} pytania`}
        onConfirm={onSubmit}
        onCancel={() => setQuestion(null)}
        confirmButtonText={
          isSubmitting ? (
            <Loading size="sm" className="px-2" variant="light" />
          ) : isEdit ? (
            "Zapisz"
          ) : (
            "Dodaj"
          )
        }
        confirmButtonDisabled={!isValid || isSubmitting}
        enforceFocus={false}
      >
        <Form>
          <Row>
            <Col md={12}>
              <InputControl
                id={"name"}
                label={"Nazwa"}
                readOnly={false}
                refs={{
                  ...register("name", {
                    required:
                      parseInt(questionType) === QuestionTypeEnum.Content.value
                        ? InputValidationConstants.required
                        : null,
                    maxLength: {
                      value: 100,
                      message: InputValidationConstants.maxLength.replace(
                        "{placeholder}",
                        100
                      ),
                    },
                  }),
                }}
                errors={errors}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <SelectControl
                id={"type"}
                label={"Typ"}
                readOnly={false}
                options={createOptionsFromEnum(QuestionTypeEnum, false)}
                refs={{
                  ...typeRegister,
                  onChange: (e) => {
                    typeRegister.onChange(e);
                    handleTypeChange(e.target.value);
                  },
                }}
                errors={errors}
              />
            </Col>
            <Col md={6}>
              <SelectControl
                id={"relatedQuestionId"}
                label={"Pytanie powiązane"}
                readOnly={false}
                options={correlatedOptions}
                refs={{
                  ...register("relatedQuestionId", {
                    // required: InputValidationConstants.required,
                  }),
                }}
                errors={errors}
              />
            </Col>
          </Row>
          {!!correlation && correlationAnswers?.length > 1 && (
            <Row>
              <Col md={12}>
                <SelectControl
                  id={"relatedAnswerId"}
                  label={
                    "Wartość powiązania (wyświetl, jeśli odpowiedź wyniosła...)"
                  }
                  readOnly={false}
                  options={correlationAnswers}
                  refs={{
                    ...register("relatedAnswerId", {
                      // required: InputValidationConstants.required,
                    }),
                  }}
                  errors={errors}
                />
              </Col>
            </Row>
          )}
          {questionType &&
            parseInt(questionType) !== QuestionTypeEnum.Content.value && (
              <Row>
                <Col md={12}>
                  <TextAreaControl
                    id={"description"}
                    label={"Opis"}
                    readOnly={false}
                    rows={2}
                    refs={{
                      ...register("description", {
                        //required: InputValidationConstants.required,
                        maxLength: {
                          value: 512,
                          message: InputValidationConstants.maxLength.replace(
                            "{placeholder}",
                            512
                          ),
                        },
                      }),
                    }}
                    errors={errors}
                  />
                </Col>
              </Row>
            )}
          <Row>
            <Col md={12} sm={12}>
              <TinymceControl
                id="content"
                onChange={(value) => setValue("content", value)}
                label="Treść"
                htmlContent={content}
                rows={3}
                editorRef={tinymceRef}
              />
            </Col>
          </Row>
          {questionType &&
            parseInt(questionType) !== QuestionTypeEnum.Content.value && (
              <>
                <Row>
                  <Col md={12}>
                    <h4>Walidacja</h4>
                  </Col>
                </Row>
                <Row>
                  {parseInt(questionType) === QuestionTypeEnum.Date.value && (
                    <>
                      <Col md={3}>
                        <DateTimeControl
                          id={"minValue"}
                          label={"Data od"}
                          required={true}
                          type="date"
                          max={getValues("maxValue")}
                          refs={{
                            ...register("minValue", {}),
                          }}
                          errors={errors}
                        />
                      </Col>
                      <Col md={3}>
                        <DateTimeControl
                          id={"maxValue"}
                          label={"Data do"}
                          required={true}
                          type="date"
                          min={getValues("minValue")}
                          refs={{
                            ...register("maxValue", {
                              min: {
                                value: getValues("minValue"),
                                message:
                                  'Data nie może być wcześniejsza niż "Data od"',
                              },
                            }),
                          }}
                          errors={errors}
                        />
                      </Col>
                    </>
                  )}
                  {parseInt(questionType) === QuestionTypeEnum.Number.value && (
                    <>
                      <Col md={3}>
                        <NumberControl
                          id={"minValue"}
                          label={"Liczba od"}
                          min={1}
                          refs={{
                            ...register("minValue", {
                              max: {
                                value: !!getValues("maxValue")
                                  ? getValues("maxValue")
                                  : 99999,
                                message:
                                  'Liczba nie może być większa niż "Liczba do"',
                              },
                            }),
                          }}
                          errors={errors}
                        />
                      </Col>
                      <Col md={3}>
                        <NumberControl
                          id={"maxValue"}
                          label={"Liczba do"}
                          refs={{
                            ...register("maxValue", {
                              min: {
                                value: getValues("minValue"),
                                message:
                                  'Liczba nie może być mniejsza niż "Liczba od"',
                              },
                            }),
                          }}
                          errors={errors}
                        />
                      </Col>
                    </>
                  )}
                  {parseInt(questionType) === QuestionTypeEnum.Text.value && (
                    <>
                      <Col md={3}>
                        <SelectControl
                          id={"displayType"}
                          label={"Sposób wyświetlania"}
                          readOnly={false}
                          options={createOptionsFromEnum(
                            {
                              firstOption: {
                                ...DisplayTypeEnum.Text_SingleLine,
                              },
                              secondOption: {
                                ...DisplayTypeEnum.Text_MultipleLines,
                              },
                            },
                            false
                          )}
                          refs={{
                            ...register("displayType", {
                              required: InputValidationConstants.required,
                            }),
                          }}
                          errors={errors}
                        />
                      </Col>
                      <Col md={3}>
                        <NumberControl
                          id={"minValue"}
                          label={"Minimalna długość"}
                          min={1}
                          max={getValues("maxValue")}
                          refs={{
                            ...register("minValue", {
                              max: !!getValues("maxValue")
                                ? {
                                    value: getValues("maxValue"),
                                    message:
                                      "Liczba nie może być większa niż max. dł.",
                                  }
                                : null,
                            }),
                          }}
                          errors={errors}
                        />
                      </Col>
                      <Col md={3}>
                        <NumberControl
                          id={"maxValue"}
                          label={"Maksymalna długość"}
                          refs={{
                            ...register("maxValue", {
                              min: {
                                value: !!getValues("minValue")
                                  ? getValues("minValue")
                                  : 1,
                                message:
                                  "Liczba nie może być mniejsza niż min. dł.",
                              },
                            }),
                          }}
                          errors={errors}
                        />
                      </Col>
                      {!!displayType &&
                        parseInt(displayType) ===
                          DisplayTypeEnum.Text_MultipleLines.value && (
                          <Col md={3}>
                            <NumberControl
                              id={"rowNr"}
                              label={"Ilość wierszy"}
                              min={1}
                              refs={{
                                ...register("rowNr", {}),
                              }}
                              errors={errors}
                            />
                          </Col>
                        )}
                    </>
                  )}
                  {parseInt(questionType) ===
                    QuestionTypeEnum.OptionList.value && (
                    <>
                      <Col md={3}>
                        <NumberControl
                          id={"maxValue"}
                          label={"Maksymalna liczba zaznaczonych"}
                          min={1}
                          refs={{
                            ...register("maxValue", {}),
                          }}
                          errors={errors}
                        />
                      </Col>
                      <Col md={3}>
                        <NumberControl
                          id={"rowNr"}
                          label={"Ilość wierszy (do tworzenia odp.)"}
                          min={1}
                          refs={{
                            ...register("rowNr", {}),
                          }}
                          errors={errors}
                        />
                      </Col>
                      {answerMax == 1 && (
                        <Col md={3}>
                          <SelectControl
                            id={"displayType"}
                            label={"Sposób wyświetlania"}
                            readOnly={false}
                            options={createOptionsFromEnum(
                              {
                                firstOption: {
                                  ...DisplayTypeEnum.List_Radio,
                                },
                                secondOption: {
                                  ...DisplayTypeEnum.List_Dropdown,
                                },
                              },
                              false
                            )}
                            refs={{
                              ...register("displayType", {
                                required: InputValidationConstants.required,
                              }),
                            }}
                            errors={errors}
                          />
                        </Col>
                      )}
                    </>
                  )}
                  {parseInt(questionType) ===
                    QuestionTypeEnum.YesNoSelect.value && (
                    <>
                      <Col md={3}>
                        <SelectControl
                          id={"displayType"}
                          label={"Sposób wyświetlania"}
                          readOnly={false}
                          options={createOptionsFromEnum(
                            {
                              firstOption: {
                                ...DisplayTypeEnum.List_Radio,
                              },
                              secondOption: {
                                ...DisplayTypeEnum.List_Dropdown,
                              },
                            },
                            false
                          )}
                          refs={{
                            ...register("displayType", {
                              required: InputValidationConstants.required,
                            }),
                          }}
                          errors={errors}
                        />
                      </Col>
                    </>
                  )}
                </Row>
                <CheckboxControl
                  id={"isRequired"}
                  label={"Czy odpowiedź jest wymagana ?"}
                  refs={{
                    ...register("isRequired"),
                  }}
                  errors={errors}
                />
                <Row>
                  <Col md={"auto"}>
                    <Button onClick={() => addAnswer()}>Dodaj odpowiedź</Button>
                  </Col>
                </Row>
                {answers?.length > 0 && (
                  <Row>
                    <Col md={12}>
                      <PageHeader content={"Odpowiedzi"} size={"md"} />
                    </Col>
                  </Row>
                )}
                {answers?.length > 0 &&
                  answers.map((answer, idx) => (
                    <Row className="border droppable-page">
                      <Col
                        md={2}
                        className="d-flex"
                        style={{
                          alignItems: "center",
                        }}
                      >
                        <b>{`Odpowiedź ${idx + 1}`}</b>
                      </Col>
                      <Col md={3}>
                        <OutputControl
                          id={`answerValue-${idx + 1}`}
                          label={"Typ"}
                          value={`${getEnumDescriptionByValue(
                            QuestionTypeEnum,
                            parseInt(answer?.type)
                          )} ${
                            !!answer?.relatedAnswerId
                              ? "- wyś. opcjonalne"
                              : "- wyś. zawsze"
                          }`}
                        />
                      </Col>
                      <Col md={5}>
                        <OutputControl
                          id={`answerValue-${idx + 1}`}
                          label={"Wartość"}
                          value={
                            answer.value?.length > 53
                              ? answer.value?.substring(0, 53) + "..."
                              : answer.value ?? ""
                          }
                        />
                      </Col>
                      <Col
                        md={2}
                        className="d-flex"
                        style={{
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        {/* {answers.length > 1 ? (
                          idx === 0 ? (
                            <Button
                              className="mr-2"
                              variant="outline-secondary"
                              onClick={() => {}}
                            >
                              <FontAwesomeIcon icon={faArrowDown} />
                            </Button>
                          ) : idx === answers.length - 1 ? (
                            <>
                              <Button
                                className="mr-2"
                                variant="outline-secondary"
                                onClick={() => {}}
                              >
                                <FontAwesomeIcon icon={faArrowUp} />
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                className="mr-1"
                                variant="outline-secondary"
                                onClick={() => {}}
                              >
                                <FontAwesomeIcon icon={faArrowUp} />
                              </Button>
                              <Button
                                className="mr-2"
                                variant="outline-secondary"
                                onClick={() => {}}
                              >
                                <FontAwesomeIcon icon={faArrowDown} />
                              </Button>
                            </>
                          )
                        ) : null} */}
                        <Button
                          className="mr-2"
                          onClick={() => editAnswer(answer)}
                          disabled={answer.isPredefined}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </Button>

                        {answers.length > 1 && (
                          <>
                            <Button
                              className="mr-1"
                              variant="outline-secondary"
                              disabled={idx === 0}
                              onClick={() => answerUp(idx)}
                            >
                              <FontAwesomeIcon icon={faArrowUp} />
                            </Button>
                            <Button
                              className="mr-2"
                              variant="outline-secondary"
                              disabled={idx === answers.length - 1}
                              onClick={() => answerDown(idx)}
                            >
                              <FontAwesomeIcon icon={faArrowDown} />
                            </Button>
                          </>
                        )}

                        <Button
                          variant="danger"
                          onClick={() => removeAnswer(idx)}
                          disabled={answer.isPredefined}
                        >
                          <FontAwesomeIcon icon={faTrashCan} />
                        </Button>
                      </Col>
                    </Row>
                  ))}
              </>
            )}
        </Form>
        <AnswerModal
          isEdit={isAnswerEdit}
          answers={answers}
          answer={answerModel}
          minValue={answerMin}
          maxValue={answerMax}
          rowNr={rowNr}
          displayType={displayType}
          setAnswer={setAnswerModel}
          setAnswers={setAnswers}
        />
      </Modal>
    </>
  );
}

export default QuestionModal;
